<div class="support-popup" [class.article-active]="selectedArticleSlug" [class.contact-active]="isContactUsPopupVisible" *ngIf="isVisible" @slideInOut 
(@slideInOut.done)="onAnimationDone($event)">
  <!-- Left-side tab strip -->
  <div class="popup-title-container">
    <img src="assets/tree-editor/left_pane/btn_left_pane_closed.svg" alt="Close" class="close-icon" (click)="close()"/>
    <div class="popup-title-text">{{ (activeTab === 'help' ? 'support_popup.lbl_tab_help' : 'support_popup.lbl_tab_support') | translate }}</div>
  </div>

  <!-- Main content area -->
  <div class="popup-content">
    <div *ngIf="isLoading && activeTab === 'help'" class="popup-spinner">
      <img src="/assets/images/icons/loading.svg" alt="Loading..." />
    </div>

    <ul class="main-tabs">
      <li>
        <button type="button" [class.active]="activeTab === 'help'" (click)="setActiveTab('help')">
          {{ "support_popup.lbl_tab_help" | translate }}
        </button>
      </li>
      <li>
        <button type="button" [class.active]="activeTab === 'support'" (click)="setActiveTab('support')">
          {{ "support_popup.lbl_tab_support" | translate }}
        </button>
      </li>
    </ul>

    <!--Content starts here -->
    <div class="popup-body">
      <div *ngIf="activeTab === 'help'">
        <!-- Ask input -->
        <form class="input-group flex-column input-group-lg mb-3 align-items-end" [formGroup]="searchForm">
          <div class="textarea-wrapper w-100">
            <textarea class="form-control input-box" formControlName="searchText"
              [placeholder]="'support_popup.lbl_ask_placeholder' | translate" [ngClass]="{ 'input-box-error': isErrorVisible }"
              rows="3"></textarea>
            <span class="clear-text" *ngIf="searchForm.get('searchText')?.value"
              (click)="searchForm.get('searchText')?.setValue('')">
              <i class="fa fa-times-circle"></i>
            </span>
          </div>

          <div class="button-group">
            <button type="button" id="support-ask" [ngClass]="searchForm.get('searchText')?.value.trim() === '' || isLoading? 'ft-btn ft-btn-inactive' : 'ft-btn ft-btn-active'"
              (click)="getAskResults(searchForm.value.searchText)"
              [disabled]="searchForm.get('searchText')?.value.trim() === '' || isLoading">
              {{ "support_popup.lbl_ask" | translate }}
            </button>

            <button *ngIf="searchForm.get('searchText')?.value.trim() !== '' && !isLoading"
              type="button" id="support-clear-search" class="ft-btn ft-btn-active" (click)="clearSearch()">
              {{ "support_popup.lbl_clear_search" | translate }}
            </button>
          </div>
        </form>

        <!-- Validation message -->
        <h4 class="text-danger mb-3" *ngIf="isErrorVisible">{{ txtValidationMsg }}</h4>

        <div *ngIf="askErrorText" class="error-section mt-3">
          <h4 class="text-danger">
            {{ askErrorText }}
          </h4>
          <p class="text-muted" *ngIf="askErrorDescription">{{ askErrorDescription }}</p>
        </div>
        <p class="initial-load-text mt-3" *ngIf="isAutoLoadedArticles && !answer && articleList?.length > 0">
          <strong class="initial-load-heading">
            {{ 'support_popup.lbl_information_heading' | translate }}
          </strong>
          <span class="justified-description">
            {{ 'support_popup.lbl_information_description' | translate }}
          </span>
        </p>

        <div *ngIf="answer || (articleList && articleList.length > 0)" class="answer-section mt-4">
          <!-- Only show the answer if user has asked a question -->
          <div *ngIf="answer" class="answer-text" [innerHTML]="convertToHtml(answer)"></div>

          <!-- Related Articles (always shown if available) -->
          <div class="related-articles mt-4" *ngIf="articleList && articleList.length > 0">
            <h4>{{ "support_popup.lbl_related_articles" | translate }}</h4>

            <div class="article-card p-3 mt-2" *ngFor="let article of articleList; let i = index"  [hidden]="i > (isAutoLoadedArticles ? 4 : 2)" (click)="openArticle(article.slug)">
              <h3 class="title" [innerHTML]="article.title"></h3>
            </div>
          </div>

          <div [@.disabled]="false">
            <app-support-article-popup *ngIf="selectedArticleSlug" [slug]="selectedArticleSlug" (closed)="closePopup()"></app-support-article-popup>
          </div>

          <div class="support-btn-container mt-4" *ngIf="answer">
            <button type="button" class="ft-btn ft-btn-active" (click)="contactSupport()">{{ "support_popup.lbl_contact_us" | translate }}</button>
          </div>

          <div *ngIf="isContactUsPopupVisible">
            <app-support-contactus-popup (closed)="closeContactUsPopup()" [searchText]="searchForm.get('searchText')?.value"
              [pageKeyword]="currentPageKeyword">
            </app-support-contactus-popup>
          </div>
        </div>
      </div>

      <app-support-tab *ngIf="hasActivatedSupportTab" [hidden]="activeTab !== 'support'"
        [openNewCaseRequestId]="openNewCaseRequestId" [prefillMessage]="supportCasePrefillMessage"></app-support-tab>
    </div>
    <!-- Content ends here -->

    <div class="popup-footer">
      <button class="ft-btn ft-btn-active-not-selected" (click)="close()">{{"lbl_cancel" | translate}}</button>
    </div>
  </div>
</div>